import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Caret"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.64018 4.36682C5.98886 3.82405 5 4.2872 5 5.13504L5 10.865C5 11.7128 5.98886 12.176 6.64018 11.6332L10.0781 8.76822C10.5579 8.36843 10.5579 7.63157 10.0781 7.23178L6.64018 4.36682Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var caret = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { caret as default };
